/* Customer reviews tabs: instant show/hide, no fade, no sliding indicator.
   Keyboard: Enter/Space activate (native <button> behaviour), plus arrow-key
   roving focus per the tabs pattern. */
(function () {
  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-up-reviews-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-up-reviews-panel]'));

    if (!tabs.length || !panels.length) return;

    function activate(tab) {
      var key = tab.getAttribute('data-up-reviews-tab');

      tabs.forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
      });

      panels.forEach(function (panel) {
        if (panel.getAttribute('data-up-reviews-panel') === key) {
          panel.hidden = false;
        } else {
          panel.hidden = true;
        }
      });
    }

    tabs.forEach(function (tab, index) {
      tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;

      tab.addEventListener('click', function () {
        activate(tab);
      });

      tab.addEventListener('keydown', function (event) {
        var targetIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = tabs.length - 1;
        }

        if (targetIndex !== null) {
          event.preventDefault();
          var targetTab = tabs[targetIndex];
          targetTab.focus();
          activate(targetTab);
        }
      });
    });
  }

  function initNav(panel) {
    var track = panel.querySelector('[data-up-reviews-track]');
    var prevBtn = panel.querySelector('[data-up-reviews-prev]');
    var nextBtn = panel.querySelector('[data-up-reviews-next]');

    if (!track || !prevBtn || !nextBtn) return;

    function step() {
      var card = track.querySelector('.up-reviews__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateState() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= max;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateState, { passive: true });
    updateState();
  }

  function initAll() {
    document.querySelectorAll('.up-reviews').forEach(function (root) {
      init(root);
      root.querySelectorAll('[data-up-reviews-panel]').forEach(initNav);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
